import OSMDPlayableScene from './OSMDPlayableScene';

/**
 * OSMDRepertoireScene
 *
 * The Repertoire surface's binding of the shared OSMDPlayableScene engine
 * (transport / cursor / accuracy / OSMDEventStream timing feedback + the play-mode
 * mechanics). All behavior is inherited from the base; this leaf exists only to pin
 * the Repertoire scene key so every existing `scene.start('OSMDRepertoireScene')`
 * consumer, the log tags, and the main.ts registration keep working unchanged.
 *
 * Sibling leaves on the same base: OSMDExerciseScene (Exercise Section, MUS-317)
 * and, once reparented, OSMDSightReadingScene (MUS-453). Any Repertoire-only
 * behavior that ever diverges from the shared base lands here, not in the base.
 */
export default class OSMDRepertoireScene extends OSMDPlayableScene {
  constructor() {
    super('OSMDRepertoireScene');
  }
}
